var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.87,
    height: 69.793,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 0.5,
    x2: 0.857,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05aed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d1dc3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(869.368 6777.085)",
    fill: "#fff",
    d: "M0 0h214v40H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fcfcfd",
    stroke: "#f4f5f6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255.87,
    height: 69.793,
    rx: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 254.87,
    height: 68.793,
    rx: 18.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-848.368 -6762.085)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943.437 6804.635v-13.6h5.1a5.4 5.4 0 0 1 2.629.584 3.89 3.89 0 0 1 1.612 1.606 5.145 5.145 0 0 1 0 4.634 3.94 3.94 0 0 1-1.627 1.6 5.54 5.54 0 0 1-2.649.578h-3.379v-2.022h3.048a3.115 3.115 0 0 0 1.5-.319 2.01 2.01 0 0 0 .863-.876c.196-.398.294-.838.285-1.282a2.735 2.735 0 0 0-.285-1.275 1.94 1.94 0 0 0-.871-.857 3.19 3.19 0 0 0-1.507-.311h-2.258v11.54zm17.873.001h-2.63l4.787-13.6h3.041l4.794 13.6h-2.629l-3.632-10.81h-.106zm.086-5.332h7.168v1.979h-7.168zm17.306 5.332v-13.6h2.463v11.538h5.989v2.065zm16.2-13.597h3.016l4.037 9.853h.159l4.035-9.853h3.016v13.6h-2.363v-9.345h-.124l-3.762 9.3h-1.766l-3.758-9.321h-.126v9.363h-2.364zm22.553 13.597v-13.6h8.844v2.065h-6.382v3.69h5.923v2.065h-5.923v3.711h6.434v2.069zm16.966-.001v-13.6h5.1a5.723 5.723 0 0 1 2.629.544 3.72 3.72 0 0 1 1.613 1.527c.379.698.569 1.483.551 2.277a4.45 4.45 0 0 1-.558 2.27 3.68 3.68 0 0 1-1.627 1.481 6.06 6.06 0 0 1-2.643.518h-3.631v-2.042h3.3a3.803 3.803 0 0 0 1.5-.252 1.79 1.79 0 0 0 .863-.75 2.42 2.42 0 0 0 .285-1.222 2.5 2.5 0 0 0-.285-1.235 1.82 1.82 0 0 0-.87-.783 3.587 3.587 0 0 0-1.507-.272h-2.257v11.539zm7.026-6.161 3.365 6.161h-2.749l-3.306-6.161zm12.49 6.162h-2.629l4.787-13.6h3.041l4.794 13.6h-2.629l-3.633-10.81h-.106zm.086-5.332h7.171v1.979h-7.171z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.374 6797.233a20.24 20.24 0 0 1-20.236 20.236 20.24 20.24 0 0 1-20.236-20.236 20.24 20.24 0 0 1 20.236-20.236 20.24 20.24 0 0 1 20.236 20.236z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.181 6802.076c.466-6.218-4.042-9.949-14.612-6.373 3.731.466 6.684 4.2 7.462 4.042s.812-1.144 1.088-2.332c.622 2.021 2.176 3.42 2.643 3.264s.5-.637.622-1.4c.31 1.245 2.797 4.198 2.797 2.799zm-15.234-7.617c1.244-5.285 4.974-12.9 11.192-11.814 2.021.466-6.686 9.482-11.192 11.814zm-9.327-7.15s-4.12-.311-3.731-1.244c.7-1.673 4.966-1.995 7.928.155 2.27 1.648 3.581 5.091 3.109 8.394-2.176-2.487-5.8-3.109-6.063-3.886-.124-.373.777-1.088 1.244-1.4-.933.259-2.86.684-3.109.311s.311-1.709.622-2.33zm-4.663 10.57c-1.169 2.173-1.865 4.353-3.109 4.353-1.088 0-.311-5.52 3.109-7.24 3.023-1.521 7.533-.673 10.415.4-3.034 1.033-5.6 4.2-6.529 3.886s0-2.332 0-2.332-2.954 3.575-3.575 3.42-.311-2.487-.311-2.487zm13.839.622c-.155-.777 0-1.554-.777-1.554s-.622.622-.777 1.554c-.108.647-1.146 11.985-.223 18.756 0 .031.026.185.026.185a6.92 6.92 0 0 0 1.333.035c.366-.018.811 0 1.294-.035a8.52 8.52 0 0 0 .875-.115v-.169c.018-6.602-1.651-18.107-1.751-18.657z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmera);
export default __webpack_public_path__ + "static/media/Palmera.d3584643331d985a2facb293fe71e92e.svg";
export { ForwardRef as ReactComponent };